<div class="eventq-schedule-block-tooltip__section">
  <p class="eventq-schedule-block-tooltip__title">{{ details().title }}</p>
  @for (row of details().timeRows; track row.label + row.range) {
    <p class="eventq-schedule-block-tooltip__line">{{ row.label }}: {{ row.range }}</p>
  }
</div>

@if (showNvrs()) {
  <div class="eventq-schedule-block-tooltip__section eventq-schedule-block-tooltip__section--divided">
    <p class="eventq-schedule-block-tooltip__title">Assigned to NVR/s:</p>
    @for (nvr of details().nvrs; track nvr) {
      <p class="eventq-schedule-block-tooltip__line">{{ nvr }}</p>
    }
  </div>
}

@if (showCreatedBy()) {
  <div class="eventq-schedule-block-tooltip__section eventq-schedule-block-tooltip__section--divided">
    <p class="eventq-schedule-block-tooltip__title">Created By:</p>
    <p class="eventq-schedule-block-tooltip__line">{{ details().createdBy }}</p>
  </div>
}
